import { usePusherChannel, usePusherEvents } from '@assembly-web/pusher';
import { datadogLogs } from '@datadog/browser-logs';
import { useQueryClient } from '@tanstack/react-query';

import { useUserDetails } from '../useUserDetails';

export function useUserFeedUpdatedEvent() {
  const queryClient = useQueryClient();
  const [{ data: userDetails }] = useUserDetails();

  const assembly = usePusherChannel(
    `private-assembly-${userDetails?.assembly.assemblyId}`
  );

  usePusherEvents(
    assembly,
    ['NEW_FEED', 'USER_ACTIVITY_FEED_UPDATED', 'GIVEN_POINTS'],
    async () => {
      try {
        const queryCache = queryClient.getQueryCache();
        const keysToInvalidate = ['userFeed', 'searchResults'];

        queryCache.getAll().forEach((query) => {
          const queryKey = query.queryKey;

          if (
            Array.isArray(queryKey) &&
            keysToInvalidate.includes(queryKey[0] as string)
          ) {
            queryClient.refetchQueries(queryKey);
          }
        });
      } catch (e) {
        datadogLogs.logger.error(
          'Refetch error on user activity feed update',
          {},
          e as Error
        );
      }
    }
  );
}
